import React, { useContext, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { ListBox } from 'primereact/listbox';
import { Toast } from 'primereact/toast';
import { ConfigContext } from '../../Context/ConfigContext';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Checkbox } from "primereact/checkbox";
import { Skeleton } from 'primereact/skeleton';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useNavigate, useParams } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import PurchaseReturnPrint from '../PrintHelper/PurchaseReturnPrint';


const PurchaseReturn = () => {
    const toast = useRef(null);
    const { apiUrl, apiHeadersJson, baseurl, store_id, auth_routes } = useContext(ConfigContext);
    const [products, setProducts] = useState([]);
    const [isPrint, setisPrint] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [focusedProduct, setFocusedProduct] = useState(null);
    const [Categories, setCategories] = useState([]);
    const [addedProducts, setAddedProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [InvoiceNumber, setInvoiceNumber] = useState('');
    const [listLoading, setListLoading] = useState(true);
    const [addLoading, setAddLoading] = useState(false);
    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [SupplierId, setSupplierId] = useState('');
    const headers = apiHeadersJson;
    const [Category, setCategory] = useState(null);
    const { purchase_return_id } = useParams();
    const navigate = useNavigate();
    const inputRefs = useRef({});
    const [lastAddedProduct, setLastAddedProduct] = useState(null);

    /// print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);


    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1
        }
    };


    const handleKeyboardInput = (num) => {
        if (focusedProduct !== null) {
            const product = addedProducts.find((p) => p.product_id === focusedProduct);
            if (product) {
                const currentQty = product.product_qty ?? '';

                const newQty = parseInt(`${currentQty}${num}`, 10);
                handleInputChange(focusedProduct, 'product_qty', newQty);
            }
        }
    };


    const handleClearInput = () => {
        if (focusedProduct !== null) {
            handleInputChange(focusedProduct, 'product_qty', 0);
        }
    };

    const handleBackspaceInput = () => {
        if (focusedProduct !== null) {
            const product = addedProducts.find((p) => p.product_id === focusedProduct);
            if (product) {
                const currentQty = (product.product_qty ?? '0').toString();
                const newQty = currentQty.slice(0, -1) || '0';
                handleInputChange(focusedProduct, 'product_qty', parseInt(newQty, 10));
            }
        }
    };


    const filteredProducts = Category
        ? products.filter((product) =>
            (product.category_id === Category.category_id) &&
            (product.product_name.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        : products.filter((product) =>
            product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const handleAddProductByBarcode = async (value, type) => {
        setAddLoading(true);
        if (!value) {
            const errorMsg = type === 'barcode' ? 'Barcode is empty' : 'Select Product First';
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: errorMsg,
                life: 1000,
            });

            // Trigger vibration for error
            if (navigator.vibrate) {
                navigator.vibrate(500); // Vibration for 500ms on error
            }

            return;
        }

        try {
            const response = await axios.get(`${apiUrl}/Masters/GetProductInfoByBarCode`, {
                params: { type, value },
                headers,
            });
            const audio = new Audio(`https://www.mamtafood.com/assets/audio/coin.mp3`);
            audio.play();
            setAddLoading(false);
            const { success, data } = response.data;
            if (success) {
                const product = data[0];
                if (product) {
                    const existingProduct = addedProducts.find((p) => p.product_id === product.product_id);

                    if (existingProduct) {
                        setAddedProducts((prev) =>
                            prev.map((p) =>
                                p.product_id === product.product_id
                                    ? { ...p, product_qty: p.product_qty + 1 }
                                    : p
                            )
                        );
                        setLastAddedProduct(product.product_id);
                    } else {
                        setAddedProducts((prev) => [
                            ...prev,
                            { ...product, product_qty: 1, product_cost: product.product_cost || 0 },
                        ]);
                        setLastAddedProduct(product.product_id);
                    }

                    // Trigger vibration for success
                    if (navigator.vibrate) {
                        navigator.vibrate(200); // Vibration for 200ms on success
                    }
                } else {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Product not found',
                        life: 1000,
                    });

                    // Trigger vibration for error
                    if (navigator.vibrate) {
                        navigator.vibrate(500); // Vibration for 500ms on error
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching product info:', error);
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Unable to fetch product info',
                life: 1000,
            });
            setAddLoading(false);
            if (navigator.vibrate) {
                navigator.vibrate(500);
            }
        } finally {
            setAddLoading(false);
        }
    };

    useEffect(() => {
        let barcodeBuffer = '';
        let timer;
        const handleKeyPress = (event) => {
            clearTimeout(timer);

            if (event.key === 'Enter') {
                if (barcodeBuffer) {
                    handleAddProductByBarcode(barcodeBuffer, 'barcode');
                    barcodeBuffer = '';
                }
            } else {
                barcodeBuffer += event.key;
            }

            timer = setTimeout(() => {
                barcodeBuffer = '';
            }, 300);
        };

        window.addEventListener('keypress', handleKeyPress);

        return () => {
            window.removeEventListener('keypress', handleKeyPress);
        };
    }, [handleAddProductByBarcode]);

    const handleRemoveProduct = (product_id) => {
        setAddedProducts((prev) => prev.filter((p) => p.product_id !== product_id));
    };

    const handleSupplierChange = (event) => {
        const selectedValue = parseInt(event.target.value, 10);
        setSupplierId(selectedValue);
    };

    const handleInputChange = (product_id, field, value) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue)) {
            setAddedProducts((prev) =>
                prev.map((p) => (p.product_id === product_id ? { ...p, [field]: numericValue } : p))
            );
        }
    };

    function generateInvoiceNumber() {
        if (purchase_return_id) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: "You Cannot Update the Invice Number", life: 1000 });
            return;
        }
        const prefix = "PR-";
        const randomNumber = Math.floor(Math.random() * 9000) + 1000;
        const invoiceNumber = prefix + randomNumber;
        setInvoiceNumber(invoiceNumber);
    }

    const handleResetForm = () => {
        setSupplierId('');
        setInvoiceNumber('');
        setAddedProducts([]);
        if (purchase_return_id) {
            navigate('/PurchaseReturnReports')
        }
    };

    const handleSubmit = async () => {

        const body = {
            purchase_return_id: purchase_return_id,
            supplier_id: SupplierId,
            store_id: store_id,
            invoice_number: InvoiceNumber,
            grand_total_amount: totalAmount,
            rows: addedProducts,
        };

        try {
            const response = await axios.post(`${apiUrl}/ReturnManagement/PurchaseReturnProducts`, body, { headers });
            setPurchaseLoading(false);
            const { success, message, cr_purchase_return_id } = response.data;

            if (success) {
                if (isPrint) {
                    await handlePrint(cr_purchase_return_id);
                }
                handleResetForm();
                fetchDropdownData();
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 1000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.log('error', error);
            setPurchaseLoading(false);
        }
    };

    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetPurchaseReturnInvoice`, { params: { purchase_return_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.puechase-invoice-container');
        if (!invoiceContainer) {
            alert("Stock Trasnfer Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
            <html>
                <head><style>${styles}</style></head>
                <body>${invoiceContainer.innerHTML}</body>
            </html>
        `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const fetchDropdownData = async () => {
        try {
            setListLoading(true);
            const [supplierRes, usersRes, productRes] = await Promise.all([
                axios.get(`${apiUrl}/Masters/GetSupplierList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/CategoryList`, { params: { store_id }, headers }),
                axios.get(`${apiUrl}/Masters/ProductList`, { params: { store_id }, headers }),
            ]);
            setListLoading(false);
            setSuppliers(supplierRes.data.data || []);
            setCategories(usersRes.data.data || []);
            setProducts(productRes.data.data || []);
        } catch (error) {
            setListLoading(false);
            console.error('Error fetching DropdownData:', error);
        }
    };

    useEffect(() => {
        store_id && fetchDropdownData();
    }, [store_id]);

    useEffect(() => {
        if (auth_routes.includes('PrintPurchaseReturn')) {
            setisPrint(true);
        }
    }, [auth_routes.length]);


    useEffect(() => {
        if (lastAddedProduct && inputRefs.current[lastAddedProduct]) {
            // Focus the input
            inputRefs.current[lastAddedProduct].focus();
            // Scroll into view
            inputRefs.current[lastAddedProduct].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }, [lastAddedProduct]);

    const calculateRowTotal = (product) => {
        return product.product_purchase_rate * product.product_qty;
    };
    const calculateRowQty = (product) => {
        return 1 * product.product_qty;
    };

    const calculateTotalAmount = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowTotal(product), 0);
    };
    const calculateQty = () => {
        return addedProducts.reduce((acc, product) => acc + calculateRowQty(product), 0);
    };

    const totalAmount = calculateTotalAmount();
    const calculatedQty = calculateQty();

    const GetList = async () => {
        try {
            const response = await axios.get(`${apiUrl}/ReturnManagement/GetPurchaseReturnProducts`, {
                params: { purchase_return_id, type: 0 },
                headers
            });
            const { success, data, rows, message } = response.data;
            if (success) {
                setAddedProducts(rows);
                setSupplierId(data[0].supplier_id);
                setInvoiceNumber(data[0].invoice_number);

            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 1000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 1000 });
        }
    };

    useEffect(() => {
        if (purchase_return_id) {
            GetList();
        }
    }, [purchase_return_id]);

    return (
        <div className="container-fluid" style={{ background: 'hsl(120deg 100% 97.06%)' }}>
            <Toast ref={toast} position="top-right" />
            <motion.div
                className="row pt-3 bg-light"
                style={{ borderBottom: "1px solid #000" }}
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.1 }}
            >
                <div className="col-md-2">
                    <h6>Purchase Return Entry</h6>
                </div>
                <div className="col-md-2">
                    {auth_routes.includes('PrintPurchaseReturn') && <div className="flex align-items-center">
                        <label htmlFor="print">
                            <Checkbox checked={isPrint} id='print' className="me-2" onChange={(e) => { setisPrint(e.target.checked) }} />
                            Print
                        </label>
                    </div>}
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-2">
                    <button className='btn btn-info btn-sm text-white w-100' onClick={() => window.open(`#/PurchaseReturn`)}>New Purchase Return</button>
                </div>
                <div className="col-md-4">
                    <div className="p-inputgroup flex-1">
                        <IconField iconPosition="left" className='w-100'>
                            <InputIcon className="pi pi-search"> </InputIcon>
                            <InputText placeholder="Search By Product Name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className='w-100' style={{ height: '35px' }} />
                        </IconField>
                    </div>
                </div>
                <div className="col-md-1"></div>
            </motion.div>

            <div className="row gap-0">
                <div className="col-md-5 border border-1 bg-light d-flex flex-column" style={{ height: "calc(100vh - 120px)" }}>
                    <motion.div
                        className="flex-grow-1"
                        style={{ overflowY: 'auto' }}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.1 }}
                    >
                        <table className="table p-0 m-0 table-hover table-bordered table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Rate</th>
                                    <th>Qty</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {addedProducts.length > 0 ? (
                                <tbody>
                                    <AnimatePresence>
                                        {addedProducts.map((product) => (
                                            <motion.tr
                                                layout
                                                key={product.product_id}
                                                initial={{ opacity: 0, x: -20 }}
                                                animate={{ opacity: 1, x: 0 }}
                                                exit={{ opacity: 0, }}
                                                transition={{ duration: 0.1 }}
                                                onClick={() => { setFocusedProduct(product.product_id); setLastAddedProduct(product.product_id); }}
                                                className={focusedProduct === product.product_id ? 'border border-2 border-danger table-active' : ''}
                                            >
                                                <td className="w-25">{product.product_name}</td>
                                                <td>{product.product_purchase_rate}</td>
                                                <td style={{ width: '130px' }}>
                                                    <div className="d-flex">
                                                        <button
                                                            type="button"
                                                            disabled={product.product_qty <= 1}
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                handleInputChange(
                                                                    product.product_id,
                                                                    'product_qty',
                                                                    product.product_qty - 1
                                                                )
                                                            }
                                                        >
                                                            <i className="pi pi-minus"></i>
                                                        </button>
                                                        <input
                                                            type="text"
                                                            className="form-control p-1"
                                                            placeholder="Qty"
                                                            value={product.product_qty}
                                                            ref={el => inputRefs.current[product.product_id] = el}
                                                            onFocus={() => setFocusedProduct(product.product_id)}
                                                            onChange={(e) => handleInputChange(
                                                                product.product_id,
                                                                'product_qty',
                                                                Number(e.target.value)
                                                            )}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-success btn-sm"
                                                            onClick={() =>
                                                                handleInputChange(
                                                                    product.product_id,
                                                                    'product_qty',
                                                                    product.product_qty + 1
                                                                )
                                                            }
                                                        >
                                                            <i className="pi pi-plus"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{calculateRowTotal(product).toFixed(2)}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleRemoveProduct(product.product_id)}
                                                    >
                                                        <i className="pi pi-trash"></i>
                                                    </button>
                                                </td>
                                            </motion.tr>
                                        ))}
                                    </AnimatePresence>
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td className="w-25 text-muted" colSpan={6}>
                                            Add Products ..........!
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </motion.div>

                    <motion.div
                        className="row my-3"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        <div className="col-md-6">
                            <select
                                className="form-select form-select-sm"
                                value={SupplierId || ""}
                                onChange={handleSupplierChange}>

                                <option value="" disabled>
                                    Select a Supplier
                                </option>
                                {suppliers.map((supplier) => (
                                    <option key={supplier.supplier_id} value={supplier.supplier_id}>
                                        {supplier.supplier_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <div className="p-inputgroup flex-1">
                                <span onClick={generateInvoiceNumber} className={`p-inputgroup-addon bg-primary `} style={{ height: '35px', cursor: 'pointer', }} >
                                    <i className="pi pi-refresh"></i>
                                </span>
                                <InputText placeholder="Invoice No" disabled value={InvoiceNumber} className='w-100' style={{ height: '35px' }} />
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        className="row bg-danger mt-auto"
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ type: "spring", stiffness: 100 }}
                    >
                        <div className="col-md-6">
                            <div className="row" style={{ marginTop: '13px' }}>
                                <div className="col-md-12">
                                    <small className='small text-light '>Total Products : <strong>{addedProducts.length}</strong></small>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <small className='small text-light '>Total Qty : <strong>{calculatedQty}</strong></small>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <small className='small text-light '>Total Amount : <strong>₹{totalAmount.toFixed(2)}</strong></small>
                                </div>
                            </div>
                            <div className="row d-flex justify-content-center align-items-center" style={{ marginTop: '17px', }}>
                                <button className='btn btn-success btn-sm ms-1 w-75' onClick={handleSubmit} disabled={dataLoading || purchaseLoading || !SupplierId || !InvoiceNumber || addedProducts.length === 0 || !store_id}>{dataLoading ? 'Preparing Print....!' : purchaseLoading ? "Loading..!" : purchase_return_id ? "Update" : "Purchase Return"}</button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row gx-7 gy-7">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, i) => (
                                    <motion.div
                                        key={num}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: i * 0.09 }}
                                        className="col-4"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-outline-light w-100 btn-sm"
                                            key={num}
                                            onClick={() => handleKeyboardInput(num)}
                                        >
                                            {num}
                                        </button>
                                    </motion.div>
                                ))}
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning w-100 btn-sm"
                                        onClick={handleClearInput}
                                    >
                                        Clear
                                    </button>
                                </div>
                                <div className="col-4">
                                    <button
                                        type="button"
                                        className="btn btn-danger w-100 btn-sm"
                                        onClick={handleBackspaceInput}
                                    >
                                        <i className='pi pi-delete-left'></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-2 d-flex flex-column">
                    {listLoading ? (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <Skeleton width="100%" height="calc(100vh - 120px)" className="rounded-0" />
                        </motion.div>
                    ) : (
                        <motion.div
                            initial={{ x: -20, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}
                            className="flex-grow-1 d-flex flex-column"
                        >
                            <div
                                style={{
                                    maxHeight: "calc(100vh - 120px)",
                                    overflowY: "auto",
                                    padding: "5px",
                                    background: '#fff',
                                    scrollbarWidth: "thin",
                                }}
                                className="d-flex flex-column gap-2"
                            >
                                {Categories.map((category, index) => (
                                    <motion.div
                                        key={index}
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ duration: 0.1, delay: Number(`0.${index}`) }}
                                    >
                                        <div
                                            onClick={() => setCategory(Category === category ? "" : category)}
                                            style={{
                                                padding: "12px 16px",
                                                cursor: "pointer",
                                                backgroundColor: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                color: Category === category ? "rgb(220 53 69)" : "#ffffff",
                                                boxShadow: Category === category
                                                    ? "0 2px 8px rgba(255, 255, 255, 0.3)"
                                                    : "0 1px 3px rgba(0, 0, 0, 0.2)",
                                                border: Category === category
                                                    ? "2px solid rgb(220 53 69)"
                                                    : "1px solid rgb(220 53 69)",
                                                transition: "all 0.2s ease-out",
                                            }}
                                            className="d-flex align-items-center gap-3"
                                        >
                                            {category.icon && (
                                                <div
                                                    style={{
                                                        width: "28px",
                                                        height: "28px",
                                                        backgroundColor: Category === category
                                                            ? "#d32f2f"
                                                            : "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: Category === category ? "#ffffff" : "rgb(220 53 69)",
                                                    }}
                                                >
                                                    {category.icon}
                                                </div>
                                            )}
                                            <span
                                                style={{
                                                    fontWeight: Category === category ? "700" : "600",
                                                    fontSize: "0.9rem",
                                                    letterSpacing: "0.3px"
                                                }}
                                            >
                                                {category.name}
                                            </span>
                                            {Category === category && (
                                                <div className="ms-auto">
                                                    <i className="pi pi-check" style={{ color: "#d32f2f", fontWeight: "bold" }}></i>
                                                </div>
                                            )}
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </div>

                <div className="col-md-5 p-0">
                    <div className="h-100 rounded-0" style={{
                        background: 'linear-gradient(90deg, #e4e8eb 0%,rgb(250, 250, 250) 100%)',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%'
                    }}>
                        <div
                            style={{
                                flex: 1,
                                overflowY: 'auto',
                                padding: '0px 12px',
                                maxHeight: "calc(100vh - 120px)",
                                scrollbarWidth: 'thin',
                                scrollbarColor: '#c1c1c1 #f1f1f1',
                            }}
                        >
                            {listLoading ? (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {[...Array(12)].map((_, i) => (
                                        <motion.div
                                            className="col-4 col-md-4"
                                            key={i}
                                            variants={itemVariants}
                                        >
                                            <div className="card h-100 border-0 shadow-sm overflow-hidden">
                                                {/* <Skeleton className="w-100" style={{ height: '120px', transform: 'none' }} /> */}
                                                <h6 className="card-title text-truncate"><Skeleton width='100%' height='18vh'></Skeleton></h6>
                                                <div className="card-body">
                                                    <Skeleton width="100%" height="20px" className="mb-2" />
                                                    <div className="d-flex justify-content-between">
                                                        <Skeleton width="60px" height="16px" />
                                                        <Skeleton width="40px" height="16px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    ))}
                                </motion.div>
                            ) : (
                                <motion.div
                                    className="row g-3"
                                    variants={containerVariants}
                                    initial="hidden"
                                    animate="visible"
                                >
                                    {filteredProducts.length > 0 ? (
                                        filteredProducts.map((product, i) => (
                                            <motion.div
                                                layout
                                                key={i}
                                                className="col-4 col-md-4"
                                                initial={{ opacity: 0, scale: 0.95 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{ duration: 0.1 }}
                                                whileHover={{ scale: 1.02 }}
                                                whileTap={{ scale: 0.98 }}
                                            >
                                                <div
                                                    className={`card h-100 border-0 shadow-sm overflow-hidden position-relative ${product.product_min_alert > product.total_remaining ? 'blink-animation' : ''
                                                        } ${addLoading ? 'pe-none' : ''}`}
                                                    onClick={() => {
                                                        // Prevent clicks during loading
                                                        if (addLoading) return;

                                                        // Check stock availability
                                                        if (Number(product?.total_remaining) === 0 || !product?.total_remaining) {
                                                            toast.current.show({
                                                                severity: 'error',
                                                                summary: 'Error',
                                                                detail: 'This product is out of stock and cannot be added.',
                                                                life: 1000,
                                                            });
                                                            return;
                                                        }

                                                        // Only proceed if product is available and not loading
                                                        handleAddProductByBarcode(product.product_id, 'id');
                                                    }}
                                                    style={{
                                                        cursor: addLoading ? 'wait' : 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        opacity: addLoading ? 0.7 : 1
                                                    }}
                                                >
                                                    <div className="ratio ratio-1x1 bg-light">
                                                        <img
                                                            src={product.product_image_url}
                                                            loading='lazy'
                                                            className="card-img-top p-2 object-fit-contain"
                                                            alt={product.product_name}
                                                            style={{ transition: 'transform 0.3s ease' }}
                                                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                        />
                                                    </div>
                                                    <div className="card-body p-3">
                                                        <h6 className="card-title text-truncate mb-2" style={{ fontSize: '0.9rem' }}>
                                                            {product.product_name}
                                                        </h6>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small">₹{product.product_purchase_rate}</span>
                                                            <div className="d-flex align-items-center">
                                                                <span className={`badge ${product.product_min_alert > product.total_remaining ? 'bg-danger' : 'bg-secondary'} me-1`}>
                                                                    {product.total_remaining}
                                                                </span>
                                                                {product.product_min_alert > product.total_remaining && (
                                                                    <i className="pi pi-exclamation-circle text-danger small"></i>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {addLoading && !listLoading && (
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            <div className="spinner-border text-primary" role="status"></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </motion.div>
                                        ))
                                    ) : (
                                        <motion.div
                                            className="col-12"
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                        >
                                            <div className="text-center py-5">
                                                <i className="pi pi-search text-muted" style={{ fontSize: '2.5rem' }}></i>
                                                <h6 className="mt-3 text-muted">No products found</h6>
                                                <p className="small text-muted">Try changing your search or filters</p>
                                            </div>
                                        </motion.div>
                                    )}
                                </motion.div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
            {isReadyToPrint && <PurchaseReturnPrint purchaseDetails={invoiceData} products={printProducts} user={user} isShow={true} />}
        </div >
    );
};

export default PurchaseReturn;
